import { PropsWithChildren, useMemo } from 'react';
import {
    AnalyticsStateOverrideContext,
    AnalyticsStateOverrideProps,
} from '../contexts/analytics-state-override-context';
import { useTracking } from '../use-tracking';

/**
 * Use this provider to override analytics state values such as screen name for all descendants of this provider
 * This should not affect the underlying analytics context state, only the values returned from useTracking
 */
export function AnalyticsStateOverrideProvider({
    children,
    ...stateOverrideProps
}: PropsWithChildren<AnalyticsStateOverrideProps>) {
    const { state } = useTracking();
    const stateOverride = useMemo(
        () => ({ ...state, ...stateOverrideProps }),
        [state, stateOverrideProps]
    );
    return (
        <AnalyticsStateOverrideContext.Provider value={{ stateOverride }}>
            {children}
        </AnalyticsStateOverrideContext.Provider>
    );
}
